import script from "./Entreprise.vue?vue&type=script&setup=true&lang=js"
export * from "./Entreprise.vue?vue&type=script&setup=true&lang=js"

import "./Entreprise.vue?vue&type=style&index=0&id=22d7d5eb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22d7d5eb"]])

export default __exports__